import jq from 'jquery';
import _ from 'underscore';
import { T_ } from '@shared/translation';
import { cdn_url } from '@shared/cdn';
import { getCSRFToken } from '@shared/cookie';
import awardUpgradeTemplate from './award-upgrade.html';

let $el;
let createMilestone;
let milestoneScope;
let milestoneData;

let project;
const upgradePrices = {};
const upgraded = {};
let projectConfig = {};

let showUpgrade = true;
let upgradeData = [];

let abTestPrehire = false;

function init() {
  if (!showUpgrade) {
    return;
  }
  if (jq('#milestone-modal-upgrade-section').is(':empty')) {
    render();
  }
  // Add QTS events for different upgrades.
  jq('input[type="checkbox"]').change(function() {
    const qtsData = {
      section: 'ProjectUpgrade',
      subsection: 'HireMe Milestone',
      label: this.checked ? 'select' : 'unselect',
      action: this.checked ? 'click' : 'unclick',
      name: 'Upgrade Type',
      value: jq(this).data('name'),
    };
    if (typeof project !== 'undefined') {
      qtsData.reference = 'project_id';
      qtsData.reference_id = project.id;
    }
    window._t.push(['user_action', qtsData]);
  });
}

function render() {
  jq('#milestone-modal-upgrade-section')
    .append(
      _.template(awardUpgradeTemplate)({
        templateVars: prepareVars(),
        T_,
      }),
    )
    .removeClass('is-hidden');
  $el = jq('#milestone-modal-upgrade-section');
  buildBind();
}

// determine whether to show upgrades upsell section
function prepareUpgradeABTest(id, master) {
  const deferred = jq.Deferred();
  const data = {
    id,
  };
  if (master) {
    data.m = 1;
  }
  jq.ajax({
    type: 'get',
    url: '/ajax/buyer/upgrade_info.php',
    data,
    dataType: 'json',
    success(response) {
      if (response.status === 'success') {
        // if can not be upgrade then skip upsell upgrade step
        if (!response.can_be_upgraded) {
          showUpgrade = false;
        }
        // if no more upgrades to upsell then skip upsell upgrade step
        upgraded.nda = response.project.NDA !== 'N';
        upgraded.nonpublic = response.project.nonpublic !== '0';
        upgraded.fulltime =
          response.project.fulltime !== '0' || response.project.hourly !== '0';
        if (upgraded.nda && upgraded.nonpublic && upgraded.fulltime) {
          showUpgrade = false;
        }
        project = response.project;
        projectConfig = response.project_config;
      } else {
        showUpgrade = false;
      }
      deferred.resolve(showUpgrade);
    },
    error() {
      showUpgrade = false;
      deferred.resolve(showUpgrade);
    },
  });
  return deferred.promise();
}

function prepareUpgradeForPreHireChat(currency_id) {
  abTestPrehire = true;
  const deferred = jq.Deferred();
  const data = {
    raw: true,
    currency: currency_id,
  };

  jq.ajax({
    type: 'get',
    url: '/buyers/on-currency-control.php',
    data,
    dataType: 'json',
    success(response) {
      if (response.status === 'success') {
        projectConfig = {
          nonpublic_price: parseFloat(response.projectConfig.nonpublic_price),
          NDA_price: parseFloat(response.projectConfig.NDA_price),
          fulltime_price: parseFloat(response.projectConfig.fulltime_price),
          currency: response.currencyArray.sign,
        };
      } else {
        showUpgrade = false;
      }
      deferred.resolve(showUpgrade);
    },
    error() {
      showUpgrade = false;
      deferred.resolve(showUpgrade);
    },
  });
  return deferred.promise();
}

function prepareVars() {
  const vars = {};
  upgradePrices.nonpublic = projectConfig.nonpublic_price;
  upgradePrices.nda = projectConfig.NDA_price;
  upgradePrices.fulltime = projectConfig.fulltime_price;
  vars.upgrade_prices = upgradePrices;
  vars.upgraded = upgraded;
  if (!abTestPrehire) {
    vars.currency = project.currency.sign;
  } else {
    vars.currency = projectConfig.currency;
  }
  return vars;
}

function buildBind() {
  if (jq.trim($el.find('.project-displayed-upgrades').html()) === '') {
    const hiddenUpgrades = $el.find('.project-hidden-upgrades');
    jq(hiddenUpgrades)
      .find('tr')
      .first()
      .appendTo($el.find('.project-displayed-upgrades'));
  }
  if (jq.trim($el.find('.project-hidden-upgrades').html()) !== '') {
    const viewMore = T_('View more upgrades');
    const viewMoreHTML = `
      <a href="#" class="upgrade-listing-more">${viewMore}</a>`;
    $el
      .find('.upgrade-listing-upgrade .upgrade-listing-description')
      .first()
      .append(viewMoreHTML);
    $el.find('.upgrade-listing-more').click(e => {
      jq(e.target).remove();
      $el.find('.project-hidden-upgrades').removeClass('is-hidden');
    });
  }
}

function doUpgrade(projectId) {
  const deferred = jq.Deferred();
  const ajaxData = {};
  ajaxData.csrf_token = getCSRFToken();
  ajaxData.data = {};
  getUpgrades();
  jq.each(upgradeData, (i, upgrade) => {
    ajaxData.data[upgrade] = 'on';

    window._t.push([
      'user_action',
      {
        section: 'ProjectUpgrade',
        subsection: 'HireMe Milestone',
        label: 'confirm payment',
        action: 'click',
        name: 'Upgrade Type',
        value: upgrade,
        reference: 'project_id',
        reference_id: projectId,
      },
    ]);
  });
  ajaxData.id = projectId;
  jq.ajax({
    type: 'post',
    url: '/ajax/buyer/onupgrade.php',
    dataType: 'json',
    data: ajaxData,
    success(resp) {
      if (resp.status === 'failed') {
        deferred.reject(resp.error);
      } else if (resp.status === 'insuffunds') {
        window.location.replace(resp.depositLink);
        deferred.reject('');
      } else {
        deferred.resolve(true);
      }
    },
    error() {
      const errorMessage = T_('Internal error, please try again later.');
      deferred.reject(errorMessage);
    },
  });
  return deferred.promise();
}

// // used for upgrade and create milestone on nonhireme award
function upgradeAndCreateMilestoneBreakdowns(data, callback, scope) {
  milestoneData = data;
  createMilestone = callback;
  milestoneScope = scope;
  const $footer = jq('.milestone-modal .modal-footer');
  const spinner = `
    <img id="award-loading" src="${cdn_url('/img/ajax-loader.gif')}"/>`;
  jq('#milestone-error').html('');
  if (upgradeData.length > 0) {
    $footer
      .append(spinner)
      .find('.btn')
      .hide();
    // preprocess
    prepareAmount(upgradeData, milestoneData)
      .then(
        () => {
          // milestone
          createMilestone.call(milestoneScope, milestoneData);
          // upgrade
          const upgradeCallData = {
            id: project.id,
            data: {},
          };
          jq.each(upgradeData, (key, upgrade) => {
            upgradeCallData.data[upgrade] = 'on';
          });
          jq('#upgradeProjectContainer').trigger('onupgradeCall', [
            upgradeCallData,
          ]);
        },
        error => {
          if (error) {
            jq('#milestone-error').html(error);
          }
        },
      )
      .always(() => {
        $footer.find('#award-loading').remove();
        $footer.find('.btn').show();
      });
  } else {
    createMilestone.call(milestoneScope, milestoneData);
  }
}

// used for upgrade and create milestone on hireme
function upgradeAndCreateMilestone(
  data,
  form,
  callback,
  scope,
  isPrehireProject = false,
) {
  milestoneData = {};
  milestoneData.milestone_amount = form.find('.milestone-amount').val();
  milestoneData.description = form.find('.milestone-descr').val();
  milestoneData.project_id = data.project_id;
  milestoneData.currency_id = data.currency_id;
  milestoneData.seller_id = data.seller_id;
  milestoneData.seller_name = data.seller_username;

  createMilestone = callback;
  const $footer = jq('.milestone-modal .modal-footer');
  const spinner = `
    <img id="award-loading" src="${cdn_url('/img/ajax-loader.gif')}" />`;
  jq('#milestone-error').html('');
  if (upgradeData.length > 0) {
    $footer
      .append(spinner)
      .find('.btn')
      .hide();
    // preprocess
    prepareAmount(upgradeData, milestoneData).then(
      () => {
        // upgrade
        doUpgrade(data.project_id)
          .then(
            () => {
              // milestone
              createMilestone.call(scope, form, isPrehireProject);
            },
            error => {
              if (error) {
                jq('#milestone-error').html(error);
              }
              $footer.find('.btn').show();
            },
          )
          .always(() => {
            $footer.find('#award-loading').remove();
          });
      },
      error => {
        jq('#milestone-error').html(error);
      },
    );
  } else {
    createMilestone.call(scope, form, isPrehireProject);
  }
}

function prepareAmount(upgradeData, milestoneData) {
  const deferred = jq.Deferred();
  const ajaxData = milestoneData;
  ajaxData.chosen_upgrades = upgradeData;
  jq.ajax({
    type: 'post',
    url: '/ajax/payment/on-preprocess-upgrades-and-milestones.php',
    dataType: 'json',
    data: ajaxData,
    headers: { 'X-XSRF-TOKEN': getCSRFToken() },
    success(response) {
      if (response.status === 'success') {
        if (response.diff_amount) {
          let uri =
            '/payments/deposit.php?' +
            `amount=${encodeURIComponent(response.diff_amount)}` +
            `&currency=${encodeURIComponent(response.currency_id)}` +
            `&id=${encodeURIComponent(response.project_id)}`;
          if (response.ref_action && response.data_token) {
            uri += `&refAction=${response.ref_action}`;
            uri += `&dataToken=${response.data_token}`;
          }
          if (response.back_url) {
            uri += `&back=${response.back_url}`;
          }
          window.location = uri;
          deferred.reject('');
        } else {
          deferred.resolve(true);
        }
      } else {
        deferred.reject(response.msg);
      }
    },
    error() {
      const errorMessage = T_('Internal error, please try again later.');
      deferred.reject(errorMessage);
    },
  });
  return deferred.promise();
}

function getUpgrades() {
  upgradeData = [];
  if (
    $el.find('#checkbox_nda').length > 0 &&
    $el.find('#checkbox_nda').is(':checked')
  ) {
    upgradeData.push('nda');
  }
  if (
    $el.find('#checkbox_private').length > 0 &&
    $el.find('#checkbox_private').is(':checked')
  ) {
    upgradeData.push('nonpublic');
  }
  if (
    $el.find('#checkbox_fulltime').length > 0 &&
    $el.find('#checkbox_fulltime').is(':checked')
  ) {
    upgradeData.push('fulltime');
  }
}

function getUpgradeTotal() {
  getUpgrades();
  let total = 0;
  jq.each(upgradeData, (i, upgrade) => {
    total += upgradePrices[upgrade];
  });
  return total;
}

export default {
  init,
  prepareUpgradeABTest,
  prepareUpgradeForPreHireChat,
  upgradeAndCreateMilestoneBreakdowns,
  upgradeAndCreateMilestone,
  getUpgradeTotal,
};
